module.exports = __webpack_public_path__ + "klue-128x128-f4d3ae67f4c2559a8f75fdbc9bfce1f7.png";